package com.zq.webproject.ui.invite

import androidx.compose.foundation.layout.Box
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.ImageBitmap

/**
 * Web 平台暂不实现保存功能
 */
@Composable
actual fun SaveScreenshotEffect(
    bitmap: ImageBitmap?,
    onSaveComplete: (Result<String>) -> Unit
) {
    // Web 暂不实现
}

/**
 * Web 平台的普通包装器（不支持截图）
 */
@Composable
actual fun CapturableContent(
    modifier: Modifier,
    shouldCapture: Boolean,
    onCaptureComplete: (ImageBitmap) -> Unit,
    content: @Composable () -> Unit
) {
    // Web 暂不实现截图，使用普通 Box 渲染内容
    Box(modifier = modifier) {
        content()
    }
}
